import API from 'services/API';

export default function getManagement() {
  return API.request({
    method: 'GET',
    url: '/appointment/getManagement',
    mapper: function (data = []) {
      return data;
    },
  });
}
